/* eslint-disable react-refresh/only-export-components */
/**
 * Héberge le state de sélection de la livraison pour toute l'application
 */
import {State} from '@synako/halitrek';
import {
  CatalogueMarketplace,
  TemperatureDeLivraison,
} from 'api-types/ffconnect';
import {LivraisonDesc} from 'api-types/ffconnect-hal';
import {ReactNode, createContext, useEffect, useRef, useState} from 'react';

export interface LivraisonsPossiblesContextValue {
  livraisonSelectionnee: State<LivraisonDesc>;
  date_de_livraison: string;
  setLivraisonSelectionnee: (selected: State<LivraisonDesc>) => void;
  effectiveTemperature: TemperatureDeLivraison;
  selectedMarketplaceId: CatalogueMarketplace | null;
  setSelectedMarketplaceId: (id: CatalogueMarketplace | null) => void;
}

export const LivraisonsPossiblesContext = createContext<
  Partial<LivraisonsPossiblesContextValue>
>({});

interface LivraisonsPossiblesContextProviderProps {
  initialLivraison: State<LivraisonDesc>;
  children: ReactNode;
}

export const LivraisonsPossiblesContextProvider: React.FC<
  LivraisonsPossiblesContextProviderProps
> = ({initialLivraison, children}) => {
  const [livraison, setLivraison] =
    useState<State<LivraisonDesc>>(initialLivraison);
  const [selectedMarketplaceId, setSelectedMarketplaceId] =
    useState<CatalogueMarketplace | null>(null);

  // Pas de setLivraison au montage : un enfant (ex: RedirectToPanier) peut déjà
  // avoir choisi une livraison précise juste avant — ses effets passent avant celui-ci —
  // et on la remplacerait par la livraison par défaut.
  const prevInitialLivraison = useRef(initialLivraison);
  useEffect(() => {
    if (prevInitialLivraison.current === initialLivraison) {
      return;
    }
    prevInitialLivraison.current = initialLivraison;
    setLivraison(initialLivraison);
  }, [initialLivraison]);

  const handleSetLivraisonSelectionnee = (selected: State<LivraisonDesc>) => {
    setLivraison(selected);
    setSelectedMarketplaceId(null);
  };

  const effectiveTemperature =
    livraison.data.temperature_effective ?? 'les_deux';

  const contextValue: LivraisonsPossiblesContextValue = {
    livraisonSelectionnee: livraison,
    date_de_livraison: livraison.data.tolede.date_de_livraison,
    setLivraisonSelectionnee: handleSetLivraisonSelectionnee,
    effectiveTemperature: effectiveTemperature,
    selectedMarketplaceId,
    setSelectedMarketplaceId,
  };

  // console.log("RERENDER LivraisonsPossiblesContext.Provider");
  return (
    <LivraisonsPossiblesContext.Provider value={contextValue}>
      {children}
    </LivraisonsPossiblesContext.Provider>
  );
};
